import styled from 'styled-components';

export const MobileDropdownMenuSubSectionLinkContainer = styled.li`
    line-height: 40px;
`;
